import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useParams } from 'react-router-dom';

import BasicLayout from 'components/BasicLayout';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { SectionTitle, Subheading, Content } from './styles';

const FaqQuestion = () => {
  const { section, question } = useParams<{ section: string; question: string }>();
  const { t } = useStoreTranslation();

  return (
    <BasicLayout title={t('customerSupport.title')}>
      <Subheading>{t(`faq.${section}.title`)}</Subheading>
      <SectionTitle>{t(`faq.${section}.questions.${question}.question`)}</SectionTitle>
      <Content>{ReactHtmlParser(t(`faq.${section}.questions.${question}.answer`))}</Content>
    </BasicLayout>
  );
};

export default FaqQuestion;
